import React, { useEffect, useState } from 'react';

export const OpacitySlider = props => {
  const {
    value,
    onChange,
    onCommit,
    min = 0,
    max = 1,
    step = 0.05,
    disabled = false,
    className = '',
  } = props;

  const [localValue, setLocalValue] = useState(
    typeof value === 'number' ? value : 0
  );

  useEffect(() => {
    if (typeof value === 'number') setLocalValue(value);
  }, [value]);

  const stopGridDrag = event => {
    event.stopPropagation();
  };

  const handleChange = event => {
    const nextValue = parseFloat(event.target.value);
    if (Number.isNaN(nextValue)) {
      return;
    }
    setLocalValue(nextValue);
    if (onChange) {
      onChange(nextValue);
    }
  };

  const handleCommit = () => {
    if (onCommit) {
      onCommit(localValue);
    }
  };

  const sliderStyle = {
    '--timeline-track':
      'linear-gradient(90deg, rgba(var(--main, 8 11 15), 0.25), rgba(var(--primary, 3 55 59), 0.85), rgba(var(--primary-d, 21 28 36), 0.85))',
    '--timeline-thumb': 'rgba(var(--secondary, 142 76 40), 0.95)',
    '--timeline-thumb-border': 'rgba(var(--main, 8 11 15), 0.85)',
  };

  return (
    <div
      className={`opacity-slider w-full board-grid-no-drag ${className}`}
      style={sliderStyle}
      onMouseDownCapture={stopGridDrag}
      onTouchStartCapture={stopGridDrag}
      onPointerDownCapture={stopGridDrag}
      onClick={stopGridDrag}
    >
      <input
        className='timeline-range w-full'
        type='range'
        min={min}
        max={max}
        step={step}
        value={localValue}
        onChange={handleChange}
        onMouseUp={handleCommit}
        onTouchEnd={handleCommit}
        onPointerUp={handleCommit}
        onBlur={handleCommit}
        disabled={disabled}
      />
    </div>
  );
};
